import { Modal } from "#shared/view/components/Modal";
import { Space } from "#shared/view/components/Space";
import { Text } from "#shared/view/components/Text";
import { Title } from "#shared/view/components/Title";
import { Button } from "#shared/view/designSystem/Button";

type Props = {
  opened: boolean;
  close: () => void;
};

export const CsvDetailsModal = ({ close, opened, children }: React.PropsWithChildren<Props>) => {
  return (
    <Modal
      opened={opened}
      onClose={close}
      size="xl"
      title="Comment construire mon fichier à charger au bon format"
    >
      <Title order={5}>Quel format de fichier charger ?</Title>
      <Text>
        {
          "Vous ne pouvez charger que des fichiers au format .csv. Depuis Excel, vous pouvez exporter votre tableau en format CSV dans le menu Fichier > Exporter Sous."
        }
      </Text>

      <Space h="md" />
      <Title order={5}>Les colonnes du fichier</Title>

      {children}

      <Space h="md" />

      <Title order={5}>Erreurs courantes</Title>
      <Text>
        {
          "Si une erreur se produit malgré le fait que vous ayez suivi tous les conseils précédents, vérifiez que les séparateurs du fichier .csv sont bien des ';'. Certaines versions d'Excel (notamment en anglais) exportent les .csv avec des ',' ce qui peut poser problème. Pour vérifier quel séparateur est utilisé, ouvrez le fichier avec un éditeur de texte et regardez entre les champs."
        }
      </Text>

      <Space h="md" />

      <Button onClick={close}>Fermer</Button>
    </Modal>
  );
};
